module.exports = __webpack_public_path__ + "static/media/menu.9a119eba.svg";